import { DtoExt } from '@/classes/scenario/DtoExt';
import { GridComplexPricePeriodExt } from '@/classes/scenario/grid/GridComplexPricePeriodExt';
import { GridComplexPricing } from '@/dto/scenario/eco/GridComplexPricing';

export enum PeriodValidation {
  valid = 'valid',
  missingPrice = 'missingPrice'
}

export class GridComplexPricingExt extends DtoExt {

  public static fromDto(dto: GridComplexPricing): GridComplexPricingExt {
    const dtoWithoutNullValues = Object.fromEntries(Object.entries(dto).filter(([_, value]) => value !== null));
    return new GridComplexPricingExt({
      ...dtoWithoutNullValues,
      periods: dto.periods?.map(GridComplexPricePeriodExt.fromDto)
    });
  }

  public prices: (number | null)[] = new Array(6).fill(null);
  public isCharge: boolean[] = new Array(6).fill(true);
  public periods: GridComplexPricePeriodExt[] = [new GridComplexPricePeriodExt()];

  constructor(options?: Partial<GridComplexPricingExt>) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): GridComplexPricing {
    return new GridComplexPricing({
      prices: this.prices,
      isCharge: this.isCharge,
      periods: this.periods && this.periods.map(p => p.toDto())
    });
  }

  public validatePeriods(): PeriodValidation[] {
    const definedPrices = this.prices.filter(price => price !== null).length ?? 0;
    return this.periods
      .map(period => period.numberOfPriceUsed())
      .map(usedPrices => (definedPrices < usedPrices ? PeriodValidation.missingPrice : PeriodValidation.valid));
  }
}
